/* =========================================================
   TOKI PARTNER DROPS ENGINE
   Namespace: window.TokiPartnerDrops
   ========================================================= */
(function () {
  "use strict";

  if (window.TokiPartnerDrops && window.TokiPartnerDrops.version) return;

  var API = window.TokiPartnerDrops = {
    version: "1.1.0"
  };

  function normalizeTag(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[-\s]+/g, "_");
  }

  function getCustomerTags() {
    var tags = window.TOKI_PARTNER_DROP_CUSTOMER_TAGS;
    return Array.isArray(tags) ? tags : [];
  }

  function isPaidUser() {
    var settings = window.TOKI_PARTNER_DROP_SETTINGS || {};
    var hidden = Array.isArray(settings.hiddenForPlanTags)
      ? settings.hiddenForPlanTags.map(normalizeTag)
      : ["wheel_plus", "vortex_pro"];

    return getCustomerTags().some(function (tag) {
      return hidden.indexOf(normalizeTag(tag)) !== -1;
    });
  }

  function parseDate(value) {
    if (!value) return null;
    var ms = Date.parse(value);
    return isFinite(ms) ? ms : null;
  }

  function isCampaignLive(campaign, placement, now) {
    if (!campaign || campaign.active === false) return false;

    var placements = Array.isArray(campaign.placements) ? campaign.placements : [];
    if (placements.length && placements.indexOf(placement) === -1 && placements.indexOf("*") === -1) {
      return false;
    }

    var start = parseDate(campaign.startAt);
    var end = parseDate(campaign.endAt);

    if (start !== null && now < start) return false;
    if (end !== null && now >= end) return false;

    return true;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function safeUrl(value) {
    var url = String(value || "").trim();
    if (!url) return "#";
    if (/^(https?:|\/|#)/i.test(url)) return url;
    return "#";
  }

  function applyTheme(frame, theme) {
    theme = theme || {};
    var map = {
      bgA: "--tpd-bg-a",
      bgB: "--tpd-bg-b",
      accent: "--tpd-accent",
      accent2: "--tpd-accent-2",
      ink: "--tpd-ink",
      muted: "--tpd-muted",
      glow: "--tpd-glow"
    };

    Object.keys(map).forEach(function (key) {
      if (theme[key]) frame.style.setProperty(map[key], String(theme[key]));
    });
  }

  function emit(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail }));
    } catch (_) {}
  }

  function buildSlide(campaign, index) {
    var disclosure = campaign.disclosure || "Sponsored";
    var sponsor = campaign.sponsorName || "Partner";
    var logo = campaign.logoUrl
      ? '<div class="tpd-logo-wrap"><img class="tpd-logo" src="' + escapeHtml(campaign.logoUrl) + '" alt="' + escapeHtml(sponsor) + '" loading="lazy" decoding="async"></div>'
      : "";

    return [
      '<article class="tpd-slide' + (index === 0 ? ' is-active' : '') + '" data-tpd-slide="' + index + '" data-tpd-campaign="' + escapeHtml(campaign.id || "") + '" aria-hidden="' + (index === 0 ? 'false' : 'true') + '">',
        '<div class="tpd-copy">',
          '<p class="tpd-kicker">' + escapeHtml(campaign.kicker || "Partner Drop") + '</p>',
          logo,
          '<h3 class="tpd-title">' + escapeHtml(campaign.title || sponsor) + '</h3>',
          '<p class="tpd-copytext">' + escapeHtml(campaign.text || "") + '</p>',
          '<a class="tpd-cta" href="' + escapeHtml(safeUrl(campaign.ctaUrl)) + '" target="_blank" rel="sponsored noopener noreferrer" data-tpd-click="' + escapeHtml(campaign.id) + '">' + escapeHtml(campaign.ctaLabel || "Explore") + '<span class="tpd-cta-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></a>',
        '</div>',
        '<div class="tpd-media">',
          '<div class="tpd-banner-shell">',
            '<img class="tpd-banner" src="' + escapeHtml(campaign.bannerUrl || "") + '" alt="' + escapeHtml(campaign.bannerAlt || sponsor) + '" loading="lazy" decoding="async">',
          '</div>',
        '</div>',
      '</article>'
    ].join("");
  }

  function renderMount(mount) {
    if (!mount || mount.dataset.tpdReady === "true") return;
    mount.dataset.tpdReady = "true";

    if (isPaidUser()) {
      mount.hidden = true;
      return;
    }

    var placement = mount.getAttribute("data-partner-drop-placement") || "wheel-pages";
    var now = Date.now();
    var all = Array.isArray(window.TOKI_PARTNER_DROP_CAMPAIGNS)
      ? window.TOKI_PARTNER_DROP_CAMPAIGNS.slice()
      : [];

    var campaigns = all
      .filter(function (campaign) {
        return isCampaignLive(campaign, placement, now);
      })
      .sort(function (a, b) {
        return Number(b.priority || 0) - Number(a.priority || 0);
      });

    if (!campaigns.length) {
      mount.hidden = true;
      return;
    }

    mount.hidden = false;

    var slidesHtml = campaigns.map(buildSlide).join("");

    mount.innerHTML = [
      '<div class="tpd-frame' + (campaigns.length === 1 ? ' is-single' : '') + '">',
        '<div class="tpd-lights" aria-hidden="true">',
          '<span class="tpd-beam tpd-beam--left"></span>',
          '<span class="tpd-beam tpd-beam--right"></span>',
        '</div>',
        '<div class="tpd-topbar">',
          '<div class="tpd-mark"><span class="tpd-mark-dot" aria-hidden="true"></span><span>Spin the Wheel Lab Partner Drops</span></div>',
          '<div class="tpd-rule" aria-hidden="true"></div>',
          '<div class="tpd-disclosure">Sponsored</div>',
        '</div>',
        '<div class="tpd-viewport">',
          '<div class="tpd-track">' + slidesHtml + '</div>',
        '</div>',
        '<div class="tpd-footer">',
          '<div class="tpd-nav">',
            '<button class="tpd-arrow tpd-prev" type="button" aria-label="Previous partner">‹</button>',
            '<button class="tpd-arrow tpd-next" type="button" aria-label="Next partner">›</button>',
          '</div>',
          '<div class="tpd-dots" aria-label="Partner carousel navigation"></div>',
          '<div class="tpd-count" aria-live="polite"></div>',
        '</div>',
      '</div>'
    ].join("");

    var frame = mount.querySelector(".tpd-frame");
    var slides = Array.prototype.slice.call(mount.querySelectorAll(".tpd-slide"));
    var dotsWrap = mount.querySelector(".tpd-dots");
    var count = mount.querySelector(".tpd-count");
    var prev = mount.querySelector(".tpd-prev");
    var next = mount.querySelector(".tpd-next");
    var index = 0;
    var timer = null;
    var impressionSeen = {};

    campaigns.forEach(function (_, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "tpd-dot" + (i === 0 ? " is-active" : "");
      dot.setAttribute("aria-label", "Show partner " + (i + 1));
      dot.dataset.index = String(i);
      dotsWrap.appendChild(dot);
    });

    var dots = Array.prototype.slice.call(mount.querySelectorAll(".tpd-dot"));

    function reportImpression(campaign) {
      if (!campaign || impressionSeen[campaign.id]) return;
      impressionSeen[campaign.id] = true;
      emit("toki:partner-drop:impression", {
        campaignId: campaign.id,
        placement: placement,
        sponsorName: campaign.sponsorName || ""
      });
    }

    function show(nextIndex, userInitiated) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });

      count.textContent = (index + 1) + " / " + slides.length;
      applyTheme(frame, campaigns[index].theme);
      reportImpression(campaigns[index]);

      if (userInitiated) restart();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (slides.length < 2) return;

      var settings = window.TOKI_PARTNER_DROP_SETTINGS || {};
      var delay = Number(settings.autoRotateMs || 6500);
      if (!(delay >= 2500)) delay = 6500;

      timer = setInterval(function () {
        show(index + 1, false);
      }, delay);
    }

    function restart() {
      stop();
      start();
    }

    prev.addEventListener("click", function () {
      show(index - 1, true);
    });

    next.addEventListener("click", function () {
      show(index + 1, true);
    });

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(Number(dot.dataset.index || 0), true);
      });
    });

    mount.addEventListener("click", function (event) {
      var link = event.target.closest("[data-tpd-click]");
      if (!link) return;

      var campaignId = link.getAttribute("data-tpd-click");
      var campaign = campaigns.filter(function (item) {
        return item.id === campaignId;
      })[0];

      emit("toki:partner-drop:click", {
        campaignId: campaignId,
        placement: placement,
        sponsorName: campaign ? (campaign.sponsorName || "") : "",
        url: link.href
      });
    });

    var settings = window.TOKI_PARTNER_DROP_SETTINGS || {};

    if (settings.pauseWhenHovered !== false) {
      mount.addEventListener("mouseenter", stop);
      mount.addEventListener("mouseleave", start);
    }

    if (settings.pauseWhenFocused !== false) {
      mount.addEventListener("focusin", stop);
      mount.addEventListener("focusout", start);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else start();
    });

    show(0, false);
    start();
  }

  API.init = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    var mounts = scope.querySelectorAll(".toki-partner-drops");
    mounts.forEach(renderMount);
  };

  function boot() {
    API.init(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    API.init(event.target || document);
  });
})();
